<template>
  <div class="login-container">
    <div class="login-left">
      <el-carousel
        class="carousel-container"
        trigger="click"
        arrow="never"
        height="1032px"
      >
        <el-carousel-item
          v-for="item in carouselImages"
          :key="item"
          style="border-radius: 8px"
        >
          <div>
            <img :src="item.imgsrc" alt="" />
            <div class="mask-layer">
              <div class="carousel-text">
                <div class="text-title">{{ item.bigTitle }}</div>
                <div class="text-describe">
                  {{ item.smallTitle }}
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="login-right">
      <div class="login-card">
        <div class="welcome-text">
          <div class="welcome-one">欢迎使用 优艺AI</div>
          <div class="welcome-two">
            优艺AI 是面向工业设计的生成式人工智能项目展示平台
          </div>
        </div>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-position="top"
          class="demo-ruleForm"
        >
          <el-form-item label="用户名:" prop="name">
            <el-input
              clearable
              class="form_input"
              v-model="ruleForm.name"
              :validate-event="false"
              placeholder="请输入您的用户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="pass">
            <el-input
              clearable
              show-password
              type="password"
              v-model="ruleForm.pass"
              :validate-event="false"
              placeholder="请输入您的密码"
              autocomplete="off"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="确认密码" prop="checkPass">
            <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
          </el-form-item> -->

          <el-form-item>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              class="submit-btn"
              >登&nbsp;&nbsp;&nbsp;录</el-button
            >
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
        <div class="login-logo">
          <div class="login-brand">优艺AI</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userLogin } from "../api/index";
import { Session } from "@/utils/storage";
import carouselimage1 from "../assets/kaiping/login-img.png";

export default {
  name: "Login",
  data() {
    var checkName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        name: "",
        pass: "",
        // checkPass: '',
      },
      rules: {
        name: [{ validator: checkName, trigger: "change" }],
        pass: [{ validator: validatePass, trigger: "change" }],
      },
      carouselImages: [
        {
          imgsrc: carouselimage1,
          bigTitle: "AI辅助工业设计方案生成",
          smallTitle:
            "该工具面向家居产品的造型概念生成，通过输入基本设计需求，辅助生成多样化的造型方案，用于项目研究、演示和设计探索。",
        },
        // {
        //   imgsrc: carouselimage2,
        //   bigTitle: "面向家居产品的AIGID方案生成",
        //   smallTitle:
        //     "该工具专注于以办公座椅为主的家居产品的造型设计，基于AIGID（人工智能生成的工业设计）技术，通过输入基本的设计需求，如风格、代表性造型和，自动生成多样化的造型方案。设计师可以通过工具快速探索不同的椅子造型选项，借助其智能生成能力，快速迭代和优化设计。该工具旨在提高设计效率，帮助设计师在造型创意阶段减少重复工作，并提供丰富的设计灵感来源。",
        // },
        // {
        //   imgsrc: carouselimage3,
        //   bigTitle: "面向智慧出行的AIGID方案生成",
        //   smallTitle:
        //     "该工具专注于智慧出行场景下的汽车外观和内饰设计，基于AIGID技术，通过输入设计需求如风格、造型和功能，自动生成多样化的方案，帮助设计师快速探索不同的设计选项。工具涵盖车身外形和内饰布局，支持从整体造型到细节优化的设计生成，满足不同风格和功能需求。通过智能生成和快速迭代，该工具可提升设计效率，减少重复性工作，激发设计灵感，为智慧出行场景下的工业设计提供高效的创意支持。",
        // },{
        //   imgsrc: carouselimage4,
        //   bigTitle: "面向3D打印服装的AIGID方案生成",
        //   smallTitle:
        //     "该工具专注于3D打印鞋的外观和内部结构设计，基于AIGID技术，通过输入具体的设计需求如功能特性、整体造型或初步草图，自动生成多样化的设计方案。它助力设计师迅速探索多种设计选项，确保满足复杂的舒适性和耐用性需求。工具覆盖从整体造型到内部结构以及特定部件的设计生成，为3D打印鞋从概念构思到细节设计提供了高效的创意支持。",
        // },
      ],
    };
  },
  methods: {
    submitForm(formName) {
      console.log("进行回车提交");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            username: this.ruleForm.name,
            password: this.ruleForm.pass,
          };
          Session.clear(); //清楚浏览器全部缓存
          userLogin(data).then(
            (response) => {
              console.log("请求成功了!", response.data.token);
              Session.set("token", response.data.token);
              this.$router.push({ path: "/home" });
              //console.log('请求成功了this.projectList!',this.projectList);
            },
            (error) => {
              console.log("请求失败了!", error);
            }
          );
          // alert('submit!');
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  // position: absolute;
  // left: 0;
  // top: 0;
  display: flex;
  align-items: center;
  width: 100%;
  // height: 100vh;
  height: 100%;
  padding: 24px 0 24px 24px;
  box-sizing: border-box;
  background: #efefef;
  .login-left {
    // float: left;
    width: 924px;
    margin-right: 12px;
    .mask-layer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to top,
        rgba(0, 0, 0, 74%),
        rgba(21, 21, 23, 0) 46%,
        rgba(255, 255, 255, 0)
      );
      .carousel-text {
        position: absolute;
        left: 24px;
        right: 24px;
        bottom: 78px;
        color: #fff;
        .text-title {
          font-family: AliMedium;
          font-size: 40px;
        }
        .text-describe {
          margin-top: 24px;
          font-family: AliRegular;
          font-size: 12px;
        }
      }
    }
    ::v-deep .el-carousel__indicators--horizontal {
      display: none; //不展示轮播图的指示器
      transform: translateX(0);
      left: 20px;
      bottom: 18px;
      .el-carousel__button {
        width: 43px;
        height: 4px;
        border-radius: 2px;
        background-color: #9e9e9e;
      }
    }
  }
  .login-right {
    // float: right;
    width: calc(100% - 936px);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .login-card {
      width: 640px;
      height: 652px;
      background: #ffffff;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 88px 80px 40px;
      box-shadow: 0 0 5px 0 #e1e1e1;
      .welcome-text {
        .welcome-one {
          color: #004c87;
          font-family: AliBold;
          font-size: 40px;
          line-height: 56px;
        }
        .welcome-two {
          color: #3d3d3d;
          font-weight: 400;
          font-family: AliMedium;
          font-size: 16px;
          line-height: 22px;
        }
      }
      .demo-ruleForm {
        margin-top: 32px;

        ::v-deep .el-form-item__label {
          padding: 0;
          color: #000;
          line-height: 25px;
          margin-bottom: 5px;
          // font-family: AliBold;
          font-weight: 700 !important;
          font-size: 18px !important;
        }
        ::v-deep .el-input__inner {
          width: 480px !important;
          height: 48px !important;
          line-height: 48px !important;
          border: 1px solid #5c5c5c;
          border-radius: 8px !important;
        }
        ::v-deep .el-input__inner::placeholder {
          color: #535353;
          font-family: AliMedium !important;
          font-size: 16px !important;
          height: 48px !important;
          line-height: 48px !important;
          opacity: 0.6;
        }
        .submit-btn {
          color: #fff;
          width: 480px;
          font-size: 20px;
          font-weight: 700;
          line-height: 48px;
          height: 48px;
          border-radius: 8px;
          margin-top: 38px;
          padding: 0;
          background: #004c87;
        }
      }
      .login-logo {
        margin-top: 54px;
        display: flex;
        width: 100%;
        justify-content: center;
      }
    }
  }
}
.carousel-container img {
  width: 924px;
  height: 1032px;
}
.login-brand {
  color: #004c87;
  font-family: AliBold;
  font-size: 36px;
  line-height: 57px;
  letter-spacing: 0;
}
</style>
